export { default } from './Header'



// WEBPACK FOOTER //
// ./src/common/Header/index.js